import React from 'react';
import { INavLink } from '../lib/Sidebar/Sidebar';

interface ISignupProgressContext {
  links: INavLink[];
  setLinks?: (e?: any) => void;
  /** Marks sidebar items complete by their `id` (see `appRoutesStaticData`). */
  completeSteps?: (completedNavIds?: string[]) => void;
}

const SignupProgressContext = React.createContext<ISignupProgressContext>({
  links: [],
});

export default SignupProgressContext;
